

import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import ListaUsuarios from "../../componentesEspeciales/usuariosAdmin/listaUsuarios";
import FiltrosUsuarios from "../../componentesEspeciales/usuariosAdmin/filtrosUsuarios";

const BADGE_TIPO = {
    Usuario:       { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)" },
    Soporte:       { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)" },
    Moderador:     { bg: "rgba(var(--violeta-bootstrap-rgb), 0.1)",  color: "var(--violeta-bootstrap)" },
    Contador:      { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado)" },
    Administrador: { bg: "rgba(var(--naranja-mapa-rgb), 0.1)",  color: "var(--naranja-mapa)" },
    SuperAdmin:    { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)" },
};

function ServiciosPorUsuario() {
    const navigate = useNavigate();
    const location = useLocation();
    const queryInicial = location.state?.params?.query || (() => {
        try {
            const stored = localStorage.getItem("admin_nav_servicios_usuario");
            if (stored) { localStorage.removeItem("admin_nav_servicios_usuario"); return JSON.parse(stored).query || ""; }
        } catch {}
        return "";
    })();

    // Buscador de usuario
    const [query, setQuery]           = useState(queryInicial);
    const [resultados, setResultados] = useState([]);
    const [buscando, setBuscando]     = useState(false);
    const [buscado, setBuscado]       = useState(false);
    const timerRef                    = useRef(null);

    // Lista paginada de usuarios
    const [lista, setLista]                 = useState([]);
    const [cargandoLista, setCargandoLista] = useState(false);
    const [pagina, setPagina]               = useState(1);
    const [paginas, setPaginas]             = useState(1);
    const [total, setTotal]                 = useState(0);

    const [filtros, setFiltros] = useState({
        conTelefono: false, conInfoBancaria: false, conInfoPersonal: false,
        conInfoProfesional: false, verificacionExitosa: false, verificacionPendiente: false,
        verificacionNegada: false, modoVendedor: false, aceptaMarketing: false, conReferido: false,
        conServiciosBorrador: false, conServiciosAprobados: false, conServiciosDesaprobados: false, conServiciosPausa: false,
    });

    function cambiarFiltros(nuevosFiltros) {
        setFiltros(nuevosFiltros);
        setPagina(1);
    }

    // Auto-busca si llegó con query inicial desde state
    useEffect(() => {
        if (queryInicial) buscarUsuario(queryInicial);
    }, []);

    useEffect(() => {
        (async () => {
            try {
                setCargandoLista(true);
                const res = await axios.post("/listar-usuarios-admin", { params: { pagina, ...filtros } });
                setLista(res.data.usuarios || []);
                setPaginas(res.data.paginas || 1);
                setTotal(res.data.total || 0);
            } catch { setLista([]); }
            finally { setCargandoLista(false); }
        })();
    }, [pagina, filtros]);

    function cambiarPagina(p) {
        setPagina(p);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function irAServiciosUsuario(u) {
        navigate("/admin/servicios-usuario", { state: { params: { usuario: u, idUsuario: u.idUsuario } } });
    }

    function onQueryChange(e) {
        const v = e.target.value;
        setQuery(v);
        if (!v.trim()) { setResultados([]); setBuscado(false); return; }
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => buscarUsuario(v.trim()), 400);
    }

    async function buscarUsuario(q) {
        try {
            setBuscando(true);
            const res = await axios.post("/buscar-usuarios", { params: { query: q } });
            setResultados(res?.data?.usuarios || []);
            setBuscado(true);
        } catch { setResultados([]); setBuscado(true); }
        finally { setBuscando(false); }
    }

    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <h1 className="h2 text-dark mb-1">Servicios</h1>
                <p className="text-muted mb-0 small">
                    {total > 0 ? `${total.toLocaleString("es-CO")} usuarios registrados` : "Explora servicios por usuario."}
                </p>
            </div>

            <div className="row justify-content-center">
                <div className="col-12 col-lg-10">

                    {/* Buscador */}
                    <div className="mb-4">
                        <div className="input-group shadow-sm">
                            <span className="input-group-text bg-white border-end-0 rounded-start-4">
                                {buscando
                                    ? <span className="spinner-border spinner-border-sm text-primary" role="status" />
                                    : <i className="bi bi-search text-muted"></i>
                                }
                            </span>
                            <input
                                type="text"
                                className="form-control border-start-0 border-end-0 px-0"
                                placeholder="Buscar usuario por nombre, @usuario o correo..."
                                value={query}
                                onChange={onQueryChange}
                                autoFocus
                            />
                            {query && (
                                <button
                                    type="button"
                                    className="btn btn-white border border-start-0 rounded-end-4 text-muted"
                                    onClick={() => { setQuery(""); setResultados([]); setBuscado(false); }}
                                    tabIndex={-1}
                                >
                                    <i className="bi bi-x-lg"></i>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Filtros */}
                    {!buscado && !query.trim() && (
                        <div className="mb-4">
                            <FiltrosUsuarios filtros={filtros} onChange={cambiarFiltros} />
                        </div>
                    )}

                    {/* Resultados de búsqueda */}
                    {buscado && (
                        <div className="mb-5">
                            {resultados.length === 0 ? (
                                <div className="border rounded-4 p-4 bg-light text-center">
                                    <i className="bi bi-person-x fs-2 text-muted"></i>
                                    <p className="text-muted small mb-0 mt-2">No se encontraron usuarios para <strong>"{query}"</strong>.</p>
                                </div>
                            ) : (
                                <>
                                    <p className="text-muted small mb-3">
                                        {resultados.length} resultado{resultados.length !== 1 ? "s" : ""} para <strong>"{query}"</strong>
                                        {resultados.length === 20 ? " — mostrando los primeros 20" : ""}
                                    </p>
                                    <div className="d-flex flex-column gap-2">
                                        {resultados.map((u) => {
                                            const estilo = BADGE_TIPO[u.tipo] || BADGE_TIPO.Usuario;
                                            const nombre = [u.nombre, u.apellido].filter(v => v && v !== "NA").join(" ") || "Sin nombre";
                                            return (
                                                <div
                                                    key={u._id}
                                                    className="card border-0 shadow-sm rounded-4"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => irAServiciosUsuario(u)}
                                                >
                                                    <div className="card-body py-3 px-4">
                                                        <div className="d-flex align-items-center gap-3">
                                                            <img
                                                                src={u.avatar || "/imagenes/marca/avatar.png"}
                                                                alt={u.username || "avatar"}
                                                                className="rounded-circle flex-shrink-0"
                                                                style={{ width: 44, height: 44, objectFit: "cover" }}
                                                            />
                                                            <div className="flex-grow-1">
                                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                    <span className="fw-semibold text-dark">{nombre}</span>
                                                                    <span className="badge rounded-pill px-2 py-1" style={{ background: estilo.bg, color: estilo.color, fontSize: "0.72rem" }}>
                                                                        {u.tipo || "Usuario"}
                                                                    </span>
                                                                </div>
                                                                <p className="text-muted small mb-0">@{u.username} · {u.email}</p>
                                                            </div>
                                                            <i className="bi bi-chevron-right text-muted"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* Lista paginada */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fw-semibold mb-0 text-dark">Todos los usuarios</h6>
                        <span className="text-muted small">Página {pagina} de {paginas}</span>
                    </div>

                    {cargandoLista ? (
                        <div className="text-center py-5">
                            <span className="spinner-border text-primary" role="status" />
                        </div>
                    ) : (
                        <ListaUsuarios
                            usuarios={lista}
                            onVer={irAServiciosUsuario}
                            labelBoton="Ver servicios"
                        />
                    )}

                    {paginas > 1 && !cargandoLista && (
                        <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                            <button
                                className="btn btn-outline-secondary btn-sm rounded-3"
                                onClick={() => cambiarPagina(pagina - 1)}
                                disabled={pagina === 1}
                            >
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            {Array.from({ length: paginas }, (_, i) => i + 1)
                                .filter(p => p === 1 || p === paginas || Math.abs(p - pagina) <= 2)
                                .reduce((acc, p, idx, arr) => {
                                    if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
                                    acc.push(p);
                                    return acc;
                                }, [])
                                .map((p, i) =>
                                    p === "..." ? (
                                        <span key={`e-${i}`} className="text-muted px-1">…</span>
                                    ) : (
                                        <button
                                            key={p}
                                            className={`btn btn-sm rounded-3 px-3 ${p === pagina ? "btn-dark" : "btn-outline-secondary"}`}
                                            onClick={() => cambiarPagina(p)}
                                        >
                                            {p}
                                        </button>
                                    )
                                )
                            }
                            <button
                                className="btn btn-outline-secondary btn-sm rounded-3"
                                onClick={() => cambiarPagina(pagina + 1)}
                                disabled={pagina === paginas}
                            >
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default ServiciosPorUsuario;
